import React from 'react';
import PropTypes from 'prop-types';
import {TableHead, TableRow} from '@mui/material';
import {StyledTableCell} from 'shared/components/Table';
import { useSelector } from 'react-redux';

const ListViewHeader = ({canBulkApprove}) => {


    const {filter} = useSelector((state) => state.digiSign);


  return (
    <TableHead>
      <TableRow>
    { filter === "pk-need-sign" && canBulkApprove && <StyledTableCell align='center' sx={{width: 50}}>
        </StyledTableCell>}
        <StyledTableCell align='center' sx={{width: 50}}>
          NO
        </StyledTableCell>
        <StyledTableCell align='center' sx={{width: 150}}>
          NOMOR PK
        </StyledTableCell>
        <StyledTableCell align='center' sx={{width: 400}}>JUDUL PK</StyledTableCell>

        <StyledTableCell align='center' sx={{width: 400}}>
          JABATAN PPPK
        </StyledTableCell>

        <StyledTableCell align='center' sx={{width: 350}}>
          PENERIMA
        </StyledTableCell>
        <StyledTableCell align='center' sx={{width: 100}}>
          TANGGAL
        </StyledTableCell>
        <StyledTableCell align='center' sx={{width: 50}}>
          STATUS
        </StyledTableCell>

        <StyledTableCell align='center' sx={{width: 150}}>
          AKSI
        </StyledTableCell>
      </TableRow>
    </TableHead>
  );
};

export default ListViewHeader;

ListViewHeader.propTypes = {
  canBulkApprove: PropTypes.bool,
};


